module.exports = __webpack_public_path__ + "img/ico_fulizhongxin.ce2c7185.png";